// src/hooks/useDocuments.ts
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { mockDocuments } from "@/mocks/helpdesk-documents";
import type { Document } from "@/types/document";

export function useDocuments(searchQuery?: string) {
    const { t } = useTranslation();
    const [documents, setDocuments] = useState<Document[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const loadCustomers = async () => {
            try {
                setLoading(true);
                // TODO: Implement actual API call
                // const response = await fetch(`/api/users${searchQuery ? `?search=${searchQuery}` : ''}`);
                // const data = await response.json();

                // Use mock data for now
                let filteredDocuments = [...mockDocuments];
                
                // Apply search filter if search query is provided
                if (searchQuery && searchQuery.length >= 3) {
                    const query = searchQuery.toLowerCase();
                    filteredDocuments = filteredDocuments.filter(
                        (document) =>
                            (document.name?.toLowerCase() || "").includes(query)
                    );
                }
                
                setDocuments(filteredDocuments);
                setError(null);
            } catch (err) {
                setError(err instanceof Error ? err : new Error(t("error.documents.failedToLoadDocuments")));
            } finally {
                setLoading(false);
            }
        };

        loadCustomers();
    }, [searchQuery]);

    const addDocument = async (document: Document): Promise<void> => {
        try {
            // TODO: Implement actual API call
            // const response = await fetch("/api/customers", {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            //     body: JSON.stringify(customer),
            // });
            // const newCustomer = await response.json();

            // Mock adding a customer
            const newDocument = {
                ...document,
                id: String(documents.length + 1),
            } as Document;
            setDocuments((prev) => [...prev, newDocument]);
        } catch (err) {
            throw err instanceof Error ? err : new Error(t("error.documents.failedToAddDocument"));
        }
    };

    const updateDocument = async (document: Document): Promise<void> => {
        try {
            // TODO: Implement actual API call
            // const response = await fetch(`/api/customers/${customer.id}`, {
            //     method: "PUT",
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            //     body: JSON.stringify(user),
            // });
            // const updatedUser = await response.json();

            // Mock updating a user
            setDocuments((prev) =>
                prev.map((d) => (d.id === document.id ? document : d))
            );
        } catch (err) {
            throw err instanceof Error ? err : new Error(t("error.documents.failedToUpdateDocument"));
        }
    };

    const deleteDocument = async (id: string): Promise<void> => {
        try {
            // TODO: Implement actual API call
            // await fetch(`/api/customers/${id}`, {
            //     method: "DELETE",
            // });
            // setCustomers((prev) => prev.filter((c) => c.id !== id));

            // Mock deleting a customer
            setDocuments((prev) => prev.filter((d) => d.id !== id));
        } catch (err) {
            throw err instanceof Error ? err : new Error(t("error.documents.failedToDeleteDocument"));
        }
    };

    return {
        documents,
        loading,
        error,
        addDocument,
        updateDocument,
        deleteDocument,
    };
} 